import { useState } from "react";
import { CheckSquare, Square } from "lucide-react";
import { PREVENTION } from "../../lib/manualKit";

const LS = "aegis-prevention-done";

export const Prevention = () => {
  const [done, setDone] = useState(() => JSON.parse(localStorage.getItem(LS) || "{}"));
  const toggle = (k) => { const n = { ...done, [k]: !done[k] }; setDone(n); localStorage.setItem(LS, JSON.stringify(n)); };
  const total = PREVENTION.reduce((a, [, i]) => a + i.length, 0);
  const n = Object.values(done).filter(Boolean).length;
  return (
    <div data-testid="manual-prevention">
      <p className="text-sm text-white/65">Stop most chargebacks before they happen. <span className="font-mono text-brand" data-testid="prevention-progress">{n}/{total}</span> in place.</p>
      <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-4 mt-5">
        {PREVENTION.map(([group, items]) => (
          <div key={group} className="panel p-5">
            <p className="label-xs text-brand">{group}</p>
            <ul className="mt-3 space-y-2">
              {items.map((it) => {
                const k = `${group}:${it}`;
                return (
                  <li key={it}><button onClick={() => toggle(k)} className="flex gap-2 text-left text-sm text-white/75 hover:text-white" data-testid={`prevent-${group.replace(/\s/g, "-").toLowerCase()}-${items.indexOf(it)}`}>
                    {done[k] ? <CheckSquare className="w-4 h-4 mt-0.5 shrink-0 text-brand" /> : <Square className="w-4 h-4 mt-0.5 shrink-0 text-white/30" />}{it}
                  </button></li>
                );
              })}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};
